
  import { Vue, Component } from 'vue-property-decorator';
  @Component
  export default class McFooterTests extends Vue {
    created() {
    }

    mounted() {
    }
  }
